import React from 'react';

export const LightArrow = (props) => (
    <svg viewBox="0 0 50 25" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M2.449.112C1.543.343.729 1.028.303 1.917c-.235.488-.26.619-.261 1.333 0 .722.024.843.274 1.375.264.56.756 1.064 12.479 12.792L25 29.625l12.205-12.208C48.928 5.689 49.42 5.185 49.684 4.625c.25-.532.274-.653.274-1.375-.001-.714-.026-.845-.26-1.333C48.914.28 47.047-.418 45.386.305c-.477.208-1.173.884-10.448 10.145L25 20.373l-9.937-9.923C5.683 1.085 5.095.515 4.599.299 3.972.025 3.09-.051 2.449.112"/>
    </svg>
)